import {AddIcon, Button, ButtonIcon, ButtonText, FormGroup} from "@hosttools/frontend";
import type {Listing} from "@hosttools/frontend/models/listing";
import {type FC, memo, useCallback, useEffect} from "react";
import {useController, useFormContext} from "react-hook-form";

import useHandleArrayField from "../useHandleArrayField";

import TaxForm from "./TaxForm";
import TaxList from "./TaxList";

const Taxes: FC = () => {
    const {control, trigger} = useFormContext<Listing>();
    const {
        fields: taxes,
        obj: tax,
        isOpen,
        onOpen,
        onEdit,
        onRemove,
        onSave,
        onCancel
    } = useHandleArrayField("taxes");

    const {
        formState: {errors}
    } = useController({
        control,
        name: "taxes",
        rules: {
            validate: useCallback(() => {
                if (isOpen) {
                    return "Please save or close form to continue";
                }
                return true;
            }, [isOpen])
        }
    });

    useEffect(() => {
        if (!isOpen) {
            trigger("taxes");
        }
    }, [trigger, isOpen]);

    return (
        <FormGroup isInsideTab error={errors?.taxes?.root?.message} label="Taxes" name="taxes.root">
            {!isOpen && (
                <Button className="self-end" variant="ghost" onPress={onOpen}>
                    <ButtonIcon as={AddIcon} />
                    <ButtonText>Tax</ButtonText>
                </Button>
            )}
            {(taxes ?? []).length > 0 && (
                <TaxList taxes={taxes} onEdit={onEdit} onRemove={onRemove} />
            )}
            {isOpen && <TaxForm tax={tax} type="percent" onCancel={onCancel} onSave={onSave} />}
        </FormGroup>
    );
};

export default memo(Taxes);
